var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex" },
    [
      _c(
        "div",
        {
          staticClass:
            "fixed top-30 z-40 w-88 flex-shrink-0 border-r border-slate-400 bg-pure-white"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "py-6 px-6 border-b border-slate-400 flex flex-col gap-3"
            },
            [
              _c(
                "div",
                [
                  _c(
                    "div",
                    { staticClass: "mb-1" },
                    [_c("BlTextBody2", { attrs: { text: "Appointments" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("BlTextTitle3", { attrs: { text: "Rooms" } })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "py-1 px-1 flex bg-slate-400",
                  style: { borderRadius: "8px", height: "2.375rem" }
                },
                _vm._l(_vm.previewTypeOptions, function(opt) {
                  return _c(
                    "div",
                    {
                      key: opt.value,
                      staticClass:
                        "h-full w-full flex items-center justify-center gap-1 rounded cursor-pointer transition-all duration-300",
                      class: [
                        _vm.previewTypeInput === opt.value
                          ? "bg-pure-white"
                          : "bg-slate-400"
                      ],
                      on: {
                        click: function($event) {
                          return _vm.onChangePreviewType(opt.value)
                        }
                      }
                    },
                    [
                      _c("BlIcon", {
                        staticClass: "w-4 h-4",
                        attrs: { icon: opt.icon, color: "slate-6" }
                      }),
                      _vm._v(" "),
                      _c("BlTextSubtitle3", { attrs: { text: opt.label } })
                    ],
                    1
                  )
                }),
                0
              )
            ]
          ),
          _vm._v(" "),
          _vm.pageLoading
            ? _c("div", {
                staticClass: "w-full grid place-items-center",
                style: { height: "calc(100vh - 18.5rem)" }
              })
            : _c(
                "div",
                {
                  staticClass: "overflow-y-auto",
                  style: { height: "calc(100vh - 18.5rem)" }
                },
                [
                  _vm.enableBranch
                    ? _c(
                        "div",
                        [
                          _vm._l(_vm.branches, function(branch) {
                            return _c("RoomGroupBranch", {
                              key: branch.id,
                              attrs: {
                                title: branch.name,
                                rooms: _vm.rooms.filter(function(i) {
                                  return i.branch_id === branch.id
                                }),
                                selectedRoomId: _vm.selectedRoomId
                              },
                              on: {
                                "select-room": function($event) {
                                  return _vm.onSelectRoom($event)
                                }
                              }
                            })
                          }),
                          _vm._v(" "),
                          _c("RoomGroupBranch", {
                            attrs: {
                              title: "No branch",
                              rooms: _vm.rooms.filter(function(i) {
                                return !i.branch_id
                              }),
                              selectedRoomId: _vm.selectedRoomId
                            },
                            on: {
                              "select-room": function($event) {
                                return _vm.onSelectRoom($event)
                              }
                            }
                          })
                        ],
                        2
                      )
                    : _c(
                        "div",
                        [
                          _c("RoomGroupBranch", {
                            attrs: {
                              title: "All rooms",
                              rooms: _vm.rooms,
                              selectedRoomId: _vm.selectedRoomId
                            },
                            on: {
                              "select-room": function($event) {
                                return _vm.onSelectRoom($event)
                              }
                            }
                          })
                        ],
                        1
                      )
                ]
              )
        ]
      ),
      _vm._v(" "),
      _vm.previewTypeInput === "calendar"
        ? _c(
            "div",
            { staticClass: "pl-88" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "h-12 px-6 sticky top-30 z-30 bg-slate-300 border-b border-slate-400 flex items-center justify-between gap-4",
                  style: { minWidth: "calc(100vw - 22rem - 0.5rem)" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "sticky top-30 left-94" },
                    [_c("BlTextBody2", { attrs: { text: _vm.masterDate } })],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "sticky top-30 right-6 flex items-center gap-2"
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("BlSelectBox", {
                            attrs: {
                              options: _vm.timeslotViewOptions,
                              dense: ""
                            },
                            on: {
                              change: function($event) {
                                return _vm.$emit("set-timeslot-view", $event)
                              }
                            },
                            model: {
                              value: _vm.timeslotView,
                              callback: function($$v) {
                                _vm.timeslotView = $$v
                              },
                              expression: "timeslotView"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("BlInputButton", {
                        attrs: {
                          type: "outlined",
                          dense: "",
                          label: "Jump to"
                        },
                        on: {
                          clicked: function($event) {
                            _vm.jumpToOpened = true
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("BlInputButton", {
                        attrs: { type: "outlined", dense: "", label: "Today" },
                        on: {
                          clicked: function($event) {
                            _vm.onDayClick({ date: new Date() })
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("BlInputButton", {
                        staticClass: "rounded-full",
                        attrs: {
                          type: "outlined",
                          dense: "",
                          icon: "chevron-left"
                        },
                        on: {
                          clicked: function($event) {
                            return _vm.onNextClick(-1)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("BlInputButton", {
                        staticClass: "rounded-full",
                        attrs: {
                          type: "outlined",
                          dense: "",
                          icon: "chevron-right"
                        },
                        on: {
                          clicked: function($event) {
                            return _vm.onNextClick(1)
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c("Timeslots", {
                attrs: {
                  isCompact: _vm.timeslotView === "compact",
                  selectedTherapist: null,
                  selectedRoom: _vm.rooms.find(function(i) {
                    return i.id === _vm.selectedRoomId
                  }),
                  selectedDate: _vm.date,
                  headers: _vm.timeslotHeaders,
                  loading: _vm.previewLoading
                },
                on: { "after-commit": _vm.fetchTimeslots }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.previewTypeInput === "list"
        ? _c("div", { staticClass: "pl-88 bg-slate-100" }, [
            _c(
              "div",
              {
                staticClass:
                  "h-16 px-6 sticky top-30 z-20 bg-slate-300 border-b border-slate-400 flex items-center justify-between gap-4",
                style: { minWidth: "calc(100vw - 22rem - 0.5rem)" }
              },
              [
                _c("div", { staticClass: "sticky top-30 left-94" }, [
                  _c(
                    "div",
                    { staticClass: "flex items-center gap-4" },
                    [
                      _c("BlInputSearch", {
                        staticClass: "w-80",
                        attrs: { input: _vm.searchInput },
                        on: { changed: _vm.onInputSearch }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "w-40" },
                        [
                          _c("BlInputFilter", {
                            attrs: { input: _vm.filterInput },
                            on: { changed: _vm.onChangeFilter }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "sticky top-30 right-6 flex items-center gap-2"
                  },
                  [
                    _c("BlInputButton", {
                      attrs: {
                        type: "outlined",
                        label: "Export to CSV",
                        loading: _vm.exportLoading
                      },
                      on: { clicked: _vm.onExport }
                    }),
                    _vm._v(" "),
                    _vm.currentUser.role.includes("admin")
                      ? _c("BlInputButton", {
                          attrs: { icon: "plus", label: "Appointment" },
                          on: {
                            clicked: function($event) {
                              _vm.newAppointmentOpened = true
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _vm.previewLoading
                  ? _c(
                      "div",
                      { staticClass: "w-full h-92 grid place-items-center" },
                      [_c("div", { staticClass: "blum-loader" })]
                    )
                  : !_vm.appointments.length
                  ? _c(
                      "div",
                      { staticClass: "grid place-items-center h-92" },
                      [
                        _vm.searchInput.model
                          ? _c("BlTextBody2", {
                              staticClass:
                                "lg:w-128 text-slate-700 text-center",
                              attrs: {
                                text: "Oops, the appointment not found."
                              }
                            })
                          : _c("BlTextBody2", {
                              staticClass:
                                "lg:w-128 text-slate-700 text-center",
                              attrs: {
                                text:
                                  "Oops, there are no Appointment available."
                              }
                            })
                      ],
                      1
                    )
                  : _c("AppointmentsTable", {
                      on: { "after-commit": _vm.fetchAppointments }
                    })
              ],
              1
            ),
            _vm._v(" "),
            _vm.totalAppointments > 25
              ? _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c("BlInputPagination", {
                      staticClass: "sticky left-94 my-10",
                      style: {
                        minWidth: "calc(100vw - 22rem - 3rem - 0.5rem)"
                      },
                      attrs: {
                        page: _vm.page,
                        perPage: _vm.perPage,
                        total: _vm.totalAppointments
                      },
                      on: {
                        changed: _vm.changePage,
                        "changed-per-page": _vm.changePerPage
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.jumpToOpened
        ? _c("JumpToDateModal", {
            attrs: { currentDate: _vm.date, dimension: "weekly" },
            on: {
              "close-modal": function($event) {
                _vm.jumpToOpened = false
              },
              submit: function($event) {
                return _vm.onDayClick({ date: $event })
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.newAppointmentOpened && _vm.currentUser.role.includes("admin")
        ? _c("NewAppointmentsModal", {
            attrs: {
              therapist: { id: null },
              room: _vm.rooms.find(function(i) {
                return i.id === _vm.selectedRoomId
              }) || { id: null },
              startDate: "",
              startTime: ""
            },
            on: {
              "close-modal": function($event) {
                _vm.newAppointmentOpened = false
              },
              "after-commit": _vm.fetchAppointments
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f909296", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f909296","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointments/Room.vue
// module id = null
// module chunks = 